export const SET_ADMIN_FINANCE_FEES_LIST = 'SET_ADMIN_FINANCE_FEES_LIST';
export const DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE = 'DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE';
export const DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE = 'DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE';


// WEBPACK FOOTER //
// ./src/features/finance/fees/constants.js